import { BASE_URL } from './config';
import React, { useEffect } from 'react';
import useEventForm from './hooks/useEventForm';
import './CreaEvento.css';

const buildInitialData = (evento, aziendaId) => ({
  titolo: evento?.titolo || '',
  descrizione: evento?.descrizione || '',
  dataInizio: evento?.dataInizio ? evento.dataInizio.substring(0, 10) : '',
  dataFine: evento?.dataFine ? evento.dataFine.substring(0, 10) : '',
  prezzo: evento?.prezzo || 0,
  immagineCopertina: null,
  fileName: evento?.copertinaName || null,
  idAzienda: evento?.idAzienda || aziendaId,
});

const CreaPacchetto = ({ evento, azienda, onFormSubmit }) => {
  const { formData, setFormData, handleChange } = useEventForm(
    buildInitialData(evento, azienda)
  );

  useEffect(() => {
    setFormData(buildInitialData(evento, azienda));
  }, [evento, azienda, setFormData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Titolo:
        <input type="text" name="titolo" value={formData.titolo} onChange={handleChange} />
      </label>
      <br />
      <label>
        Descrizione:
        <input
          type="text"
          name="descrizione"
          value={formData.descrizione}
          onChange={handleChange}
        />
      </label>
      <br />
      <label>
        Data:
        <input type="date" name="dataInizio" value={formData.dataInizio} onChange={handleChange} />
      </label>
      <br />
      <label>
        Data Fine:
        <input type="date" name="dataFine" value={formData.dataFine} onChange={handleChange} />
      </label>
      <br />
      <label>
        Prezzo:
        <input
          type="number"
          name="prezzo"
          min="0"
          step="0.01"
          value={formData.prezzo}
          onChange={handleChange}
        />
      </label>
      <br />
      <label>
        Immagine di copertina:
        <input type="file" name="immagineCopertina" accept="image/*" onChange={handleChange} />

        {/* In modifica la copertina salvata non era visibile: restava solo il
            nome del file. /util/cover/{idEvento} la serve come immagine. */}
        {formData.immagineCopertina ? (
          <figure className="copertina-anteprima">
            <img src={formData.immagineCopertina} alt="Nuova copertina scelta" />
            <figcaption>Nuova immagine - sostituira' quella attuale al salvataggio</figcaption>
          </figure>
        ) : (
          evento?.id && (
            <figure className="copertina-anteprima">
              <img src={`${BASE_URL}/util/cover/${evento.id}`} alt="Copertina attuale" />
              <figcaption>
                Copertina attuale{formData.fileName ? ` - ${formData.fileName}` : ''}
              </figcaption>
            </figure>
          )
        )}
      </label>
      <button type="submit">Invia</button>
    </form>
  );
};

export default CreaPacchetto;
